import React, { Fragment } from "react";

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
  colors,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import {
  AdditionalDrivers,
  Qualifications,
  Skeleton,
  VehicleCard,
} from "./components";
import { DrivingDetailsProps } from "./types";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  subHeader: {
    color: colors.blueGrey[600],
    marginBottom: theme.spacing(3),
  },
  negativeMargin: {
    marginLeft: `-${theme.spacing(2)}`,
    marginRight: `-${theme.spacing(2)}`,
  },
  noContentText: {
    marginBottom: theme.spacing(3),
  },
}));

const DrivingDetails: React.FC<DrivingDetailsProps> = ({
  additionalDrivers = [],
  loading = false,
  certifications = [],
  vehicleAssignments,
  onMileageUpdateClick = () => {},
  onUpdateInsuranceClick = () => {},
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return loading ? (
    <Skeleton />
  ) : (
    <Card data-test="driving-details-card">
      <CardHeader title="Driving details" />
      <Divider />
      <CardContent>
        <Grid container spacing={isMobile ? 0 : 7}>
          <Grid item xs={12} sm={6}>
            <Typography className={classes.subHeader} variant="h2">
              My vehicles
            </Typography>
            {vehicleAssignments && vehicleAssignments.length ? (
              vehicleAssignments.map(assignment => (
                <VehicleCard
                  key={assignment.id}
                  onUpdateClick={onMileageUpdateClick}
                  onUpdateInsuranceClick={onUpdateInsuranceClick}
                  {...assignment}
                />
              ))
            ) : (
              <Typography className={classes.noContentText}>
                No vehicles have been assigned to your profile at this time.
              </Typography>
            )}
            {Boolean(additionalDrivers?.length) && (
              <Fragment>
                <Typography className={classes.subHeader} variant="h2">
                  Additional drivers
                </Typography>
                <AdditionalDrivers additionalDrivers={additionalDrivers} />
              </Fragment>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography className={classes.subHeader} variant="h2">
              My qualifications
            </Typography>
            <div className={clsx(isMobile && classes.negativeMargin)}>
              <Qualifications certifications={certifications} />
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DrivingDetails;
